import React from 'react'

export default function About(props) {
  return (
    <div>
      <h1 style={{color:props.mode==='dark' ? "white" : "#042743"}}>About Us</h1>
    </div>
  )
}
